import { render, staticRenderFns } from "./research-date.vue?vue&type=template&id=eeffa630&scoped=true"
import script from "./research-date.vue?vue&type=script&lang=js"
export * from "./research-date.vue?vue&type=script&lang=js"
import style0 from "./research-date.vue?vue&type=style&index=0&id=eeffa630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeffa630",
  null
  
)

export default component.exports